import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bath',
  templateUrl: './icon-bath.component.html',
  styles: []
})
export class IconBathComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
